module.exports = require('./lib/OutsideClick');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@gorangajic/react-outside-click/index.js
// module id = 235
// module chunks = 58